import { render } from "./expenses-model.vue?vue&type=template&id=25f7d464"
import script from "./expenses-model.vue?vue&type=script&lang=js"
export * from "./expenses-model.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__